import AttributeRow from '@/components/AttributeRow';
import AttributeRowImage from '@/components/AttributeRowImage';
import ContentSection, { ContentSectionFlushContent, ContentSectionFooterButton, ContentSectionHeader } from '@/components/ContentSection';
import { getGenderSportCoverImageSrc } from '@/components/GenderSportCoverImage';
import Page from '@/components/Page';
import PageHeader from '@/components/PageHeader';
import PageLayout from '@/components/PageLayout';
import StandingsTable from '@/components/StandingsTable';
import OrganizationSubNav from '@/components/subNavs/OrganizationSubNav';
import { isTypename } from '@sblive-sports/api-client-js';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';
import { OrganizationsShowQuery } from 'queries';
import { entryPoint } from 'react_rails/entryPoint';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import OutbrainAd from '@/components/ads/OutbrainAd';

export default entryPoint(function Show({ query: { organization } }: { query: OrganizationsShowQuery }) {
  if (!isTypename(organization, 'TeamOrganization')) throw 'Incorrect organization!'; // for TS

  return (
    <Page subNav={<OrganizationSubNav organization={organization} />}>
      <PageLayout
        sidebar={
          <>
            <MinuteMediaAd placement="SIDEBAR" />
            <ContentSection>
              <ContentSectionHeader right={<ApplicationShareButton path={organization.webStandingsPath} />}>
                {organization.label} Standings
              </ContentSectionHeader>
              <ContentSectionFlushContent>
                <StandingsTable teamStandings={organization.teamStandings} />
              </ContentSectionFlushContent>
              <ContentSectionFooterButton href={organization.webStandingsPath}>Full Standings</ContentSectionFooterButton>
            </ContentSection>
            <MinuteMediaAd placement="SIDEBAR_2" />
          </>
        }
      >
        <ContentSection>
          <PageHeader right={<ApplicationShareButton />}>{organization.label} Info</PageHeader>
          <AttributeRowImage
            src={organization.coverImage || getGenderSportCoverImageSrc(organization.genderSport.key)}
            alt={organization.name}
          />
          <AttributeRow title="Name">{organization.fullName || organization.name}</AttributeRow>
          <AttributeRow title="Sport">{organization.genderSport.name}</AttributeRow>
          <AttributeRow title="State">{organization.state.name}</AttributeRow>
          {organization.ancestors.map(ancestor => (
            <AttributeRow key={ancestor.id} title={ancestor.label}>
              {ancestor.fullName || ancestor.name}
            </AttributeRow>
          ))}
        </ContentSection>
        <OutbrainAd />
      </PageLayout>
    </Page>
  );
});
